{
  "cancelCompletePlanCard": {
    "title": "Choose Which Plans to Cancel",
    "description": "Select the product you no longer need. If you remove any plan from the bundle, you'll pay full price for the individual plans you keep.",
    "mainCTA": {
      "idle": "Continue Cancellation",
      "partial": "Continue Cancellation",
      "cancelAll": "Cancel Everything"
    },
    "secondaryCTA": {
      "idle": "Close",
      "keepBundle": "Keep Complete for {0} off",
      "dismiss": "Cancel Anyway"
    },
    "notices": {
      "bundleDiscount": {
        "title": "Cancelling {0} on its own costs ${1}/{2} more",
        "message": "Complete bundles all three plans for {0} less. Keep only two and pay full price for each"
      },
      "subscriptionEnd": {
        "title": "Your subscription will end at the end of your current billing cycle",
        "message": "You'll keep full access to all your plans until then, and you can reactivate any time before it ends."
      }
    }
  }
}
